<template>
<v-container class="fluid grid-list-lg">
    <h1>Last update: {{TipsLastUpdate}}</h1>
    <v-switch v-model="ShowTipsWithSuggestionOnly" :label="`Show Tips with suggestion only`"></v-switch>
    <v-layout class="hidden-xs-only desktop-view ma-2 pa-2" :class="item.predictions.length > 0 ? 'orange white--text' : 'cyan white--text'" v-for="(item) in filteredList" :key="item.hkjcmatchid" wrap>
        <v-flex xs3>
            <v-layout column>
                <span class="display-3">#{{item.matchnum}}</span>
                <span class="body-2">
            <v-icon color="white">mdi-calendar</v-icon>
            {{item.matchtime.split(' ')[0]}}
          </span>
                <span class="body-2">
            <v-icon color="white">mdi-alarm</v-icon>
            {{item.matchtime.split(' ')[1]}}
          </span>
            </v-layout>
        </v-flex>
        <v-flex xs5>
            <v-layout column>
                <span class="subheading mb-4">
            <v-icon color="white">mdi-flag</v-icon>
            {{item.matchname}}
          </span>
                <span class="headline">{{item.hometeam}}</span>
                <span class="headline">{{item.awayteam}}</span>
            </v-layout>
        </v-flex>
        <v-flex xs4>
            <v-layout column>
                <span class="subheading mb-4">
            <v-icon color="white">mdi-soccer</v-icon>預測
            <v-icon color="purple" @click="openLink(item.link)">mdi-link-variant</v-icon>
          </span>
                <span class="title mt-2" v-for="(preItem, preIndex) in item.predictions" :key="preIndex">
            {{preItem.side}}({{preItem.oddtype == '主客和' ? '*' : preItem.handicap}})@{{preItem.odd}}
            <!-- <span class="caption">...{{preItem.datetime.split(' ')[1]}}</span> -->
                </span>
            </v-layout>
        </v-flex>
    </v-layout>

    <v-layout column class="hidden-sm-and-up mobile-view ma-2 pa-4" :class="item.predictions.length > 0 ? 'orange white--text' : 'cyan white--text'" v-for="(item) in filteredList" :key="item.hkjcmatchid + '_M'" wrap>
        <v-flex xs12>
            <v-layout>
                <v-flex xs4 class="display-3">#{{item.matchnum}}</v-flex>
                <v-flex xs8>
                    <v-layout column>
                        <v-layout wrap>
                            <v-flex xs6 class="body-2">
                                <v-icon color="white">mdi-calendar</v-icon>
                                {{item.matchtime.split(' ')[0].substr(-5)}}
                            </v-flex>
                            <v-flex xs6 class="body-2">
                                <v-icon color="white">mdi-alarm</v-icon>
                                {{item.matchtime.split(' ')[1]}}
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <span class="ml-2 title">
                  <v-icon color="white">mdi-flag</v-icon>
                  {{item.matchname}}
                </span>
                        </v-layout>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-flex>
        <!-- <v-divider /> -->
        <v-flex xs12 class="mt-4">
            <v-layout column>
                <span class="display-1">{{item.hometeam}}</span>
                <span class="display-1">{{item.awayteam}}</span>
            </v-layout>
        </v-flex>

        <!-- <v-divider /> -->
        <v-flex xs12 class="mt-4">
            <v-layout wrap>
                <v-flex xs9>
                    <v-layout column>
                        <span class="subheading">
                <v-icon color="white">mdi-soccer</v-icon>預測
                <v-icon color="purple" @click="openLink(item.link)">mdi-link-variant</v-icon>
              </span>
                        <span
                class="title mt-2"
                v-for="(preItem, preIndex) in item.predictions"
                :key="preIndex"
              >
                {{preItem.side}}({{preItem.handicap}})@{{preItem.odd}}
                <span
                  class="caption"
                >...{{preItem.datetime.split(' ')[1]}}</span>
                        </span>
                    </v-layout>
                </v-flex>

                <v-flex xs3>
                    <!-- <v-btn  fab dark color="grey" @click="openLink(item.link)"><v-icon>mdi-link-variant</v-icon></v-btn> -->
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
export default {
    data() {
        return {
            Tips: [],
            TipsLastUpdate: "",
            ShowTipsWithSuggestionOnly: false
        };
    },
    async created() {
        this.$vs.loading({
            type: "sound"
        });
        const response = await this.$http.get("football/rhinoaijson");
        this.$vs.loading.close();
        const tipsArr = response.data;
        this.Tips = tipsArr.matches;
        this.TipsLastUpdate = tipsArr.lastupdate;
    },
    methods: {
        getPredictionColor(str) {
            if (str == "主") {
                return {
                    color: "cyan"
                };
            }
            return {
                color: "red"
            };
        },
        getFormattedDateTime(str) {
            return str.split(" ")[1];
        },
        openInNewWindow(url) {
            window.open(url);
        },
        computeBackgroundColor(val) {
            if (val.predictions.length > 0) {
                return "green";
            }
            return "grey darken-1 white--text";
        },
        openLink(link) {
            window.open(link);
        }
    },
    computed: {
        filteredList: function () {
            if (this.ShowTipsWithSuggestionOnly) {
                return this.Tips.filter(function (x) {
                    return x.predictions.length > 0;
                });
            }
            return this.Tips;
        }
    }
};
</script>

<style>
#core-view {
    height: 100%;
}
</style>
